import Component from '@apps-pages/login/component';
/**
 * @import internal modules
 */
import {LoginActionCreator } from "@apps-store/action-creator";
import * as URL from "@apps-enums/index";
/**
 * @import external modules
 */

import * as React from "react";
import { connect } from "react-redux";
import { Dispatch , bindActionCreators } from "redux";
import * as Lodash from 'lodash';


class Container extends React.PureComponent<any, any> {
    /**
     * @public
     * @constructor
     * @param { any } props 
     * @return { }
     */
    public constructor(props: any){

        super(props);

        this.state = {
            authentification:true, 
            checked:[false,false],
            connexionError: false,
            emptyError:false,
            faillure: false,
            success:true
        };
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmitValue = this.onSubmitValue.bind(this);
    }

    /**
     * @method redirectToNewUrl
     */
    public redirectToNewUrl() {

        this.props.history.push(URL.EnumUrl.DEMO)

    }
    /**
     * manipulation des valeurs des inputs
     * @public
     * @method onSubmitValue
     * @param { React.ChangeEvent<HTMLInputElement>  }  event
     * @return {any }
     */
    public onSubmitValue(event: React.ChangeEvent<HTMLInputElement>){

        event.preventDefault();

        if(!Lodash.isEmpty(this.state.identifiant) && !Lodash.isEmpty(this.state.password)){

            const user = {

                identifiant: this.state.identifiant,
                password: this.state.password
    
            }
    
            this.props.LoginActionCreator(user);
            

        }else if(Lodash.isEmpty(this.state.identifiant) || Lodash.isEmpty(this.state.password)){
            
            this.setState({ emptyError: true})
            
        }

    }
    /**
     * Cycle de vie React : componentWillReceiveProps
     * @public
     * @method componentWillReceiveProps
     * @param { any  }  nextProps
     * @return {any }
     */
    public componentWillReceiveProps = (nextProps: any) =>{
        if(nextProps.data !== this.props.data){
            if(!Lodash.isUndefined(nextProps.data)){ this.redirectToNewUrl()}
        }else if(nextProps.error !== this.props.error){
            if(!Lodash.isUndefined(nextProps.error)){ this.setState({ connexionError: true})}
        }

        
    }
     
    /* {
                    if( this.state.checked[0] || this.state.checked[1]){ }
                }
    /**
     * manipulation des valeurs des inputs
     * @public
     * @method onChange
     * @param { React.ChangeEvent<HTMLInputElement>  }  event
     * @return {any }
     */
    public onChange(event: React.ChangeEvent<HTMLInputElement>){

        event.preventDefault();
        this.setState({[event.target.name]: event.target.value, emptyError: false, connexionError: false,});
    
    }
    /**
     * manipulation des valeurs des inputs
     * @public
     * @method onChangeRadio
     * @param { number }  event
     * @return {any }
     */
    public onChangeRadio =( param: number) =>(event: React.ChangeEvent<HTMLInputElement>)=>{

        event.preventDefault();
        
        const checked: any[] = [];

        for( let i = 1; i <= Math.ceil(this.state.checked.length ); i++ ){
            checked.push(false)
        }
        checked[param] = true;
        
        this.setState({ checked, emptyError: false, connexionError: false,})

    }
    
    /**
     * Cycle de vie de React : render
     * @public
     * @method render
     * @param {}
     * @return { any }
     */
    public render() {
      
        return <Component {...this.props} {...this.state} onSubmitValue={this.onSubmitValue} onChange={this.onChange} onChangeRadio={this.onChangeRadio}/>
    }
}

/**
 * @function mapStateToProps
 * @param { any }  state 
 * @return { any }
 */
const mapStateToProps = (state : any) => ({ data:state.login.data, error:state.login.error });


const mapDispatchToProps = (dispatch : Dispatch) =>
    bindActionCreators({
        LoginActionCreator
    }, dispatch);


export default connect(mapStateToProps,mapDispatchToProps)(Container);







// WEBPACK FOOTER //
// ./src/apps/components/@pages/login/container.tsx